import AdminNavigationLayout from 'shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import Button from 'shared/Buttons/Button/Button'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useSetRecoilState } from 'recoil'
import { useParams } from 'react-router-dom'
import checkpointsTableAtom from '../../components/CheckpointsTable/checkpointsTable.atom'
import useStateWithChange from 'shared/hooks/useStateWithChange'
import projectCheckpointsApi from '../../projectCheckpoints.api'
import CheckpointSheet from '../../components/CheckpointSheet'
import useProjectCheckpoint from '../../hooks/useAdminTableProjectCheckpoint'
import { useEffect, useMemo, useState } from 'react'
import ThreeDotsLoader from 'shared/Loaders/ThreeDotsLoader'
import CheckpointCriteria from './CheckpointCriteria'
import Card from 'shared/Cards/Card'
import SlideSelect from 'shared/Inputs/SlideSelect'
import CheckpointArtifacts from './CheckpointArtifacts'
import eventBus from 'services/eventBus'

const CheckpointPage = () => {
  const params = useParams()
  const id = params.id

  const { wait, loading } = useHttpLoader()
  const { checkpoint } = useProjectCheckpoint(id)

  const [checkpointDraft, setState, handleChange] = useStateWithChange(checkpoint)

  useEffect(() => {
    setState(checkpoint)
  }, [checkpoint])

  const setTableState = useSetRecoilState(checkpointsTableAtom)

  const [selectedSlide, setSelectedSlide] = useState('main-settings')
  const slidesOptions = useMemo(() => {
    return [
      { value: 'main-settings', title: `Основные настройки` },
      { value: 'artifacts', title: 'Артефакты КТ' },
    ]
  }, [])

  const handleSave = () => {
    wait(
      projectCheckpointsApi.update({ ...checkpointDraft, duration: checkpointDraft.duration * 86400 }, id),
      (resp) => {
        if (resp.status === 'success') {
          eventBus.pub('ntf.message', { type: 'info', message: 'Изменения успешно применены' })
          setTableState((prev) => {
            const exists = prev.items.some((item) => item.id === id)
            return {
              ...prev,
              items: exists
                ? prev.items.map((item) => (item.id === id ? resp.body : item))
                : [resp.body, ...prev.items],
            }
          })
        }
      }
    )
  }

  const renderMainSettings = () => (
    <div className='flex-lines'>
      <CheckpointSheet checkpoint={checkpointDraft} onChange={handleChange}>
        <div className='form-footer'>
          <div className='inline-flex-gap'>
            <Button theme='primary' loading={loading} onClick={handleSave} style={{ width: 'fit-content' }}>
              Обновить
            </Button>
            <Button
              theme='danger'
              loading={loading}
              onClick={() => eventBus.pub('ntf.message', { type: 'info', message: 'Удаление временно не работает' })}
              style={{ width: 'fit-content' }}
            >
              Удалить
            </Button>
          </div>
        </div>
      </CheckpointSheet>
      <Card type='normal'>
        <CheckpointCriteria checkpointId={id} />
      </Card>
    </div>
  )

  const renderContent = () => {
    switch (selectedSlide) {
      case 'main-settings':
        return renderMainSettings()
      case 'artifacts':
        return <CheckpointArtifacts checkpointId={id} />
      default:
        return null
    }
  }

  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='defaultWithBackButton'>
        <div className='flex-space-between'>
          <div className='inline-flex-gap' style={{ gap: '2.5em' }}>
            <h2 className='page--header'>Контрольная точка</h2>
          </div>
        </div>
        {(loading || !checkpoint) && (
          <div className='flex-page-center'>
            <ThreeDotsLoader />
          </div>
        )}
        {checkpointDraft && (
          <div className='flex-lines'>
            <SlideSelect
              options={slidesOptions}
              selectedOption={selectedSlide}
              onSelect={(val) => setSelectedSlide(val)}
            />
            {renderContent()}
          </div>
        )}
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default CheckpointPage
